module.exports = __webpack_public_path__ + "5febfe862686f9601a4312f072982fd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/TWS.jpg
// module id = 891
// module chunks = 0